import React from 'react';
import { cn } from '../../../../utilities/cn';

interface StatusPillProps {
  status: string;
  count?: number;
  className?: string;
}

const getStatusClasses = (status: string) => {
  switch (status) {
    case 'Pass':
      return 'bg-pass/10 text-pass';
    case 'Alert':
      return 'bg-alert/10 text-alert';
    case 'Fail':
      return 'bg-fail/10 text-fail';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  count,
  className = '',
}) => {
  const statusClasses = getStatusClasses(status);

  return (
    <span
      className={`rounded-md px-2 py-0.5 text-xs font-semibold ${statusClasses} ${className}`}
    >
      {status}
      {count !== undefined ? `: ${count}` : ''}
    </span>
  );
};

// Wrapper component for multiple status pills
interface StatusPillGroupProps {
  data: Record<string, number>;
  order?: string[];
  className?: string;
}

export const StatusPillGroup: React.FC<StatusPillGroupProps> = ({
  data,
  order = ['Fail', 'Alert', 'Pass'],
  className = '',
}) => {
  const keys = order ?? Object.keys(data);

  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {keys.map((key) => {
        const value = data[key];
        // Only render if value > 0
        if (value <= 0) return null;

        return <StatusPill key={key} status={key} count={value} />;
      })}
    </div>
  );
};

export default StatusPill;
